import React from 'react';

const GraphArea = () => {
  return (
<svg viewBox="0 0 64 64">
    <defs>
        <linearGradient x1="100.803534%" y1="49.9603622%" x2="0%" y2="49.9603622%" id="linearGradient-1">
            <stop stopColor="#F2FAFC" offset="0%"></stop>
            <stop stopColor="#B5E3F5" offset="50.2058699%"></stop>
            <stop stopColor="#C8EAF7" offset="74.4721284%"></stop>
            <stop stopColor="#F2FAFC" offset="100%"></stop>
        </linearGradient>
    </defs>
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <rect id="Rectangle" fill="url(#linearGradient-1)" x="0" y="0" width="64" height="64"></rect>
    </g>
</svg>
  )
}

export default GraphArea